import moment from 'moment';
import { ensureTrailingSlash } from '../../../utils/url/url';
import Rest, { NoAuthRest } from '../../../utils/rest/rest';

const apiUrl = ensureTrailingSlash(process.env.REACT_APP_API_URL);
const apiPrefix = 'api/v1/';

export const User = Object.freeze({
  INTERPRETER_SIGNIN_STARTED: 'INTERPRETER_SIGNIN_STARTED',
  INTERPRETER_SIGNIN_FINISHED: 'INTERPRETER_SIGNIN_FINISHED',
  INTERPRETER_SIGNIN_ERROR: 'INTERPRETER_SIGNIN_ERROR',
  UPDATE_TOKEN_DATA: 'UPDATE_TOKEN_DATA',
  SET_SIGNED_IN: 'SET_SIGNED_IN',
  UPDATE_USER_DATA: 'UPDATE_USER_DATA',
  UPDATE_NEW_USER_DATA: 'UPDATE_NEW_USER_DATA',
  UPDATE_NEW_USER_DATA_ERROR: 'UPDATE_NEW_USER_DATA_ERROR',
});

export const requestUserSignInAction = () => {};

export const allowUserLoginAction = () => {};

export const setSignedIn = (value) => {
  return {
    type: User.SET_SIGNED_IN,
    payload: value,
  };
};

export const refreshUserData = () => {
  return async (dispatch) => {
    // get account
    const accountPath = `${apiUrl}${apiPrefix}user/account`;
    const userData = await Rest.get(accountPath);

    console.log('refreshUserData - userData', userData);

    dispatch({
      type: User.UPDATE_USER_DATA,
      payload: userData,
    });
  };
};

export const interpreterLogin = (username, password) => {
  return async (dispatch) => {
    try {
      console.log('interpreterLogin - start');
      // start
      dispatch({ type: User.INTERPRETER_SIGNIN_STARTED });

      // login
      const loginPath = `${apiUrl}oauth/token`;
      const result = await Rest.getToken(loginPath, username, password);
      const tokenData = doCreateTokenData(result);
      dispatch(setTokenData(tokenData));

      // get account
      const accountPath = `${apiUrl}${apiPrefix}user/account`;
      const userData = await Rest.get(accountPath);

      console.log('interpreterLogin - userData', userData);

      // update user data
      dispatch({
        type: User.UPDATE_USER_DATA,
        payload: userData,
      });

      // user is signed in
      dispatch({ type: User.SET_SIGNED_IN, payload: true });

      // finished
      dispatch({ type: User.INTERPRETER_SIGNIN_FINISHED });

      return Promise.resolve({ tokenData, userData: userData });
    } catch (error) {
      console.log('interpreterLogin ERROR', error);
      // error
      dispatch({ type: User.INTERPRETER_SIGNIN_ERROR, payload: error });
    }
  };
};

export const userLogin = (username) => {
  return (dispatch) => {
    dispatch({
      type: User.UPDATE_USER_DATA,
      payload: { username },
    });

    return Promise.resolve();
  };
};

export const getToken = () => {
  return async (dispatch, getState) => {
    // get current token data
    const { tokenData } = getState().user;

    // check if expired
    if (isTokenExpired(tokenData)) {
      // refresh token data
      const path = `${apiUrl}oauth/token`;
      const result = await Rest.renewToken(path, tokenData.refresh_token);
      const newTokenData = doCreateTokenData(result);
      dispatch(setTokenData(newTokenData));

      // return token
      return Promise.resolve(result.access_token);
    }

    // return token
    return Promise.resolve(tokenData.access_token);
  };
};

export const isTokenExpired = (tokenData) => {
  if (tokenData === null) {
    return true;
  }

  const { expiryTime } = tokenData;
  return moment().isAfter(expiryTime);
};

const doCreateTokenData = (tokenData) => {
  const { access_token, refresh_token, expires_in } = tokenData;
  return {
    access_token,
    refresh_token,
    expiryTime: moment().add(expires_in, 'seconds'),
  };
};

export const setTokenData = (tokenData) => {
  return {
    type: User.UPDATE_TOKEN_DATA,
    payload: tokenData,
  };
};

export const doSignup = (data) => {
  return async (dispatch) => {
    try {
      const { firstname, lastname, email, password } = data;
      // update newUser data
      dispatch({
        type: User.UPDATE_NEW_USER_DATA,
        payload: { firstname, lastname, email, password },
      });
      const path = `${apiUrl}user/create_user`;
      const result = await NoAuthRest.post(path, {
        firstname,
        lastname,
        username: email,
        password,
      });
      return Promise.resolve(result.data);
    } catch (error) {
      console.log('doSignup ERROR', error);
      // error
      dispatch({ type: User.UPDATE_NEW_USER_DATA_ERROR, payload: error });
    }
  };
};

const INIT_STATE = {
  userData: null,
  tokenData: null,
  signedIn: false,
  signingIn: false,
  signInError: null,
  newUser: null,
  newUserError: null,
};

export const userReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case User.UPDATE_TOKEN_DATA:
      return { ...state, tokenData: action.payload };
    case User.SET_SIGNED_IN:
      return { ...state, signedIn: action.payload };
    case User.UPDATE_USER_DATA:
      return { ...state, userData: action.payload };
    case User.INTERPRETER_SIGNIN_STARTED:
      return { ...state, signingIn: true, signInError: null };
    case User.INTERPRETER_SIGNIN_FINISHED:
      return { ...state, signingIn: false };
    case User.INTERPRETER_SIGNIN_ERROR:
      return { ...state, signingIn: false, signInError: action.payload };
    case User.UPDATE_NEW_USER_DATA:
      return { ...state, newUser: action.payload };
    case User.UPDATE_NEW_USER_DATA_ERROR:
      return { ...state, newUserError: action.payload };
    default:
      return state;
  }
};
